import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PROPERTY_ASSOCIATION } from "../apiRoutes";

type Options<T> = UseMutationOptions<any, Error, T, unknown>;

/** PATCH /property-user-associations/{id} — non-null fields only (dates, share, role). */
export const useUpdatePropertyAssociationMutation = (queryParams?: Options<{ id: number; data: any }>) =>
  useMutation({
    mutationFn: async ({ id, data }: { id: number; data: any }) =>
      await axiosAuth.patch(`${PROPERTY_ASSOCIATION}/${id}`, data),
    ...queryParams,
  });

/** DELETE /property-user-associations/{id} — ends the association (sets end date, inactive). */
export const useRemovePropertyAssociationMutation = (queryParams?: Options<{ id: number; reason?: string }>) =>
  useMutation({
    mutationFn: async ({ id, reason }: { id: number; reason?: string }) =>
      await axiosAuth.delete(`${PROPERTY_ASSOCIATION}/${id}`, { params: reason ? { reason } : undefined }),
    ...queryParams,
  });
